<script setup lang="ts">
import { usePortalContext } from '@/composables/usePortalContext'
import { PageProps } from '@/types'
import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = withDefaults(
  defineProps<{
    contentWidthClass?: string
  }>(),
  {
    contentWidthClass: 'max-w-2xl',
  },
)

const { t } = useI18n()

const page = usePage<PageProps>()
const { portal } = usePortalContext()
const firstToast = computed(() => page.props.toasts?.[0] ?? null)
</script>

<template>
  <div class="relative">
    <AuthBackground :variant="portal" />
    <Toaster />

    <div class="absolute top-8 left-8 z-10">
      <Link href="/">
        <img src="@assets/images/logo.svg" alt="FinEstHub" class="hidden h-12 lg:block" />
      </Link>
    </div>

    <div class="absolute flex min-h-screen w-full flex-col items-center justify-center py-12">
      <div class="w-full p-4" :class="props.contentWidthClass">
        <Message v-if="firstToast" :severity="firstToast.severity" class="mb-4" closable sticky>
          <div>{{ t(`toasts.${firstToast.key}.summary`) }}</div>
          <div class="font-normal">
            {{ t(`toasts.${firstToast.key}.detail`) }}
          </div>
        </Message>

        <slot />
      </div>

      <div class="mt-6 opacity-60">
        <LanguageSwitcher />
      </div>
    </div>
  </div>
</template>
